<template>
  <div class="page">
    <div
      style="
        position: sticky;
        left: 0;
        top: 0;
        z-index: 15;
        padding-bottom: 16px;
        background-color: var(--charts_bgc);
      ">
      <div class="title">所选REITs表现</div>
      <div class="tips">
        <i class="el-icon-warning" />
        下属图表将默认对于该部分的自选股进行自定义指数制作，但如果发生期间调仓，暂时不进行该部分portfolio管理对应的功能，可期待在后续功能研发或在我司后续的化数据库平台中测试使用
      </div>
      <div class="line"></div>
      <div class="flex items-center" style="margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144))">
        <CSelect
          middle
          class="dsfsdfds"
          @CSelect_select_val="changeSelect1"
          :options="select_options_1"
          :clearable="false"
          :default="select_value_1"
          >计算方式</CSelect
        >
        <CSelect
          middle
          class="ererrde"
          @CSelect_select_val="changeSelect2"
          :options="select_options_2"
          :clearable="false"
          :default="select_value_2"
          >加权方式</CSelect
        >
        <div class="flex items-center sgdsg">
          权重限制
          <div class="flex items-center" style="margin-left: 15px">
            <el-input
              type="number"
              placeholder="上限"
              style="width: 45px"
              v-model="quan_up_rate" />&nbsp;%&nbsp;&nbsp;上限
            <el-tooltip
              style="margin-left: 4px"
              class="item"
              effect="dark"
              content="单个个券的权重上限不可低于1/组合内个券数"
              placement="top">
              <i
                class="el-icon-question"
                style="
                  font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
                  margin-left: 16px;
                  color: rgb(64, 158, 255);
                "></i>
            </el-tooltip>
          </div>
          <div
            class="flex items-center"
            style="margin-left: calc(var(--ROOTFONTFIZE) * (20 / 144))">
            <el-input
              type="number"
              placeholder="下限"
              style="width: 45px"
              v-model="quan_down_rate" />&nbsp;%&nbsp;&nbsp;下限
            <el-tooltip
              style="margin-left: 4px"
              class="item"
              effect="dark"
              content="单个个券的权重下线不可高于1/组合内个券数"
              placement="top">
              <i
                class="el-icon-question"
                style="
                  font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
                  margin-left: 16px;
                  color: rgb(64, 158, 255);
                "></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="flex items-center" style="margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144))">
        <div class="hgfhd">
          纳入天数
          <el-input type="number" placeholder="纳入天数" style="width: 120px" v-model="day_count" />
          交易日
          <el-tooltip
            style="margin-left: 4px"
            class="item"
            effect="dark"
            content="表示个券上市后多少个交易日以后，再纳入到组合的计算中。一般指数由于IPO初期不稳定，首日一般均不纳入组合计算"
            placement="top">
            <i
              class="el-icon-question"
              style="
                font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
                margin-left: 10px;
                color: rgb(64, 158, 255);
              "></i>
          </el-tooltip>
        </div>
        <div class="flex items-center popikoj">
          回报期间
          <DateTimePick v-model="date_2" :clearable="false" @change="dateTimePickChange2" />
        </div>
        <div class="ysdgs">
          <CSelect
            middle
            @CSelect_select_val="cascaderChange1"
            :options="cascader_options_1"
            :clearable="false"
            :default="cascader_value_1"
            >选择基准</CSelect
          >
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div style="margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144))">
      <Case1
        @changeQueryString2="changeQueryString2"
        @saveCfg="saveCfg"
        :default_config="default_config"
        :queryString="queryString1"
        :activeGroup="activeGroup"
        :quan_down_rate="quan_down_rate"
        :quan_up_rate="quan_up_rate" />
      <div class="line" style="margin-bottom: 16px"></div>
      <div>
        <CButtons2
          :dButtons1="btn_select_options"
          :defaultVal="btn_select_value"
          @Cbtns="btnSelectChange" />
      </div>
      <div v-if="queryString2">
        <Chart1 v-if="btn_select_value === '走势对比'" :queryString="queryString2" />
        <Chart2 v-if="btn_select_value === '收益构成'" :queryString="queryString2" />
        <Chart3 v-if="btn_select_value === '期间分派率'" :queryString="queryString2" />
      </div>
      <div
        v-else
        v-loading="true"
        element-loading-text="该自选股组合没有添加个券"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)"
        style="height: 360px"></div>
    </div>
  </div>
</template>

<script>
import CSelect from '@/components/Basic/CSelect';
import DateTimePick from '@/components/Basic/DateTimePick';
import CCascader from '@/components/Basic/CCascader';
import CButtons2 from '@/components/Basic/CButtons.vue';
import Case1 from './Case1.vue';
import Chart1 from './Chart1.vue';
import Chart2 from './Chart2.vue';
import Chart3 from './Chart3.vue';

import { getDateInfo, sleep } from '@/utils';

export default {
  props: {
    nav_list: Array,
    default_config: Object,
  },
  components: { CSelect, DateTimePick, CCascader, CButtons2, Case1, Chart1, Chart2, Chart3 },
  data() {
    const BENCHMARKNAME = JSON.parse(localStorage.getItem('BENCHMARKNAME')) || [];
    return {
      select_options_1: [
        {
          label: '价格指数',
          value: '0',
        },
        {
          label: '全收益指数',
          value: '1',
        },
      ],
      select_value_1: '0',
      select_options_2: [
        {
          label: '流通市值',
          value: 'market_cap_float',
        },
        {
          label: '总市值',
          value: 'market_cap',
        },
        {
          label: '等权',
          value: 'equal',
        },
        {
          label: '自定义',
          value: 'custom',
        },
      ],
      select_value_2: 'market_cap_float',
      date_2: [],
      cascader_value_1: '中证REITs（全收益）',
      cascader_options_1: BENCHMARKNAME,
      btn_select_value: '走势对比',
      btn_select_options: ['走势对比', '收益构成', '期间分派率'],
      day_count: 30,
      quan_up_rate: 1,
      quan_down_rate: 0,
      queryString2: '',
    };
  },
  computed: {
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    activeGroup() {
      return this.nav_list.find((item) => item.active);
    },
    queryString1() {
      const r_type = '公募REITs';
      const codes = this.activeGroup ? this.activeGroup.reit_codes.join('&codes=') : '';
      const cap_name = this.select_value_2;
      const ben_name = this.cascader_value_1;
      const fuquan = this.select_value_1;
      const n = this.day_count;
      const start_date = getDateInfo(this.date_2[0]).dateString;
      const end_date = getDateInfo(this.date_2[1]).dateString;
      const cap = this.quan_up_rate / 100;
      const floor = this.quan_down_rate / 100;
      const group_name = this.activeGroup ? this.activeGroup.name : '';
      return `r_type=${r_type}&codes=${codes}&cap_name=${cap_name}&ben_name=${ben_name}&fuquan=${fuquan}&n=${n}&cap=${cap}&floor=${floor}&start_date=${start_date}&end_date=${end_date}&group_name=${group_name}`;
    },
  },
  watch: {
    activeGroup: {
      handler: function (value) {
        const cfg = value ? value.performance_config : this.default_config;
        const {
          n,
          start_date,
          end_date,
          quan_up_rate,
          quan_down_rate,
          fuquan,
          cap_name,
          ben_name,
        } = cfg;
        this.date_2 = [
          start_date ? new Date(start_date) : new Date(),
          end_date ? new Date(end_date) : new Date(),
        ];
        // 计算方式
        this.select_value_1 = fuquan + '';
        // 加权方式
        this.select_value_2 = cap_name;
        // 基准
        this.cascader_value_1 = ben_name;
        //权重
        this.quan_down_rate = quan_down_rate * 100;
        this.quan_up_rate = quan_up_rate * 100;
        //纳入天数
        this.day_count = n;
      },
      immediate: true,
    },
  },
  methods: {
    async saveCfg(cfg, flag) {
      // if (!this.activeGroup) return;
      if (this.lock_update) return;
      this.lock_update = true;
      const formData = new FormData();
      const performance_config = {
        ben_name: this.cascader_value_1,
        cap_name: this.select_value_2,
        fuquan: this.select_value_1,
        n: this.day_count,
        quan_down_rate: this.quan_down_rate / 100,
        quan_up_rate: this.quan_up_rate / 100,
        start_date: getDateInfo(this.date_2[0]).dateString,
        end_date: getDateInfo(this.date_2[1]).dateString,
        quan_zhong_cfg: cfg,
      };
      const id = (this.activeGroup || {}).id || ' __DEFAULT__';
      formData.append('group_id', id);
      formData.append('performance_config', JSON.stringify(performance_config));
      const { data } = await this.$https.post('/api/v2/update_user_reit_group_config', formData);
      if (data.code !== 200) {
        this.$message.error(data.msg);
        await sleep(200);
        this.lock_update = false;
        return;
      }
      if (!flag) {
        this.$message.success('保存配置成功');
      }
      if (!this.activeGroup) {
        if (performance_config.length > 0) {
          this.$emit('update:default_config', performance_config);
        }
      } else {
        this.$emit(
          'update:nav_list',
          this.nav_list.map((item, i) => {
            if (item.active) {
              return {
                ...item,
                performance_config,
              };
            }
            return item;
          })
        );
      }
      await sleep(200);
      this.lock_update = false;
    },
    changeQueryString2(v) {
      this.queryString2 = v;
    },
    btnSelectChange(v) {
      this.btn_select_value = v;
    },
    cascaderChange1(v) {
      this.cascader_value_1 = v;
    },
    dateTimePickChange2() {},
    changeSelect1(v) {
      this.select_value_1 = v;
    },
    changeSelect2(v) {
      this.select_value_2 = v;
    },
  },
};
</script>

<style scoped lang="less">
/* 针对Chrome, Safari, Edge, Opera */
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 针对Firefox */
/deep/input[type='number'] {
  -moz-appearance: textfield;
}

.flex {
  display: flex;
}
.items-center {
  align-items: center;
}

.page {
  // width: 100%;
  width: calc(100% - 30px);
  padding-right: 30px;
  height: calc(100% - var(--ROOTFONTFIZE) * (30 / 144));
  overflow: auto;
  color: var(--chart_title);
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  &::-webkit-scrollbar-track {
    background-color: var(--scrollbar-track);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb);
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
}

.title {
  font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
  color: var(--el-header-text-color);
}
.tips {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 2px;
  margin-top: 10px;
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  background-color: var(--cascader-bgc);
  .el-icon-warning {
    color: #409eff;
  }
}
.line {
  width: 100%;
  margin-top: 16px;
  border-bottom: 1px dashed var(--el-header-text-color);
  opacity: 0.2;
}

/deep/.dsfsdfds .el-select {
  --val3: 200px !important;
}
.ererrde {
  margin-left: 40px;
  /deep/.el-select {
    --val3: 240px !important;
  }
}
.sgdsg {
  margin-left: calc(var(--ROOTFONTFIZE) * (40 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  /deep/.el-input {
    margin-left: 0;
    input {
      height: calc(var(--ROOTFONTFIZE) * (40 / 144));
      line-height: calc(var(--ROOTFONTFIZE) * (40 / 144));
      font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
      padding: 0 6px;
      color: var(--Select-color2);
      border: none;
      background-color: var(--Btn-bgc);
      &::placeholder {
        text-align: center;
        // font-size: 12px;
      }
    }
  }
}

.hgfhd {
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  /deep/.el-input {
    margin-left: calc(var(--ROOTFONTFIZE) * (15 / 144));
    input {
      height: calc(var(--ROOTFONTFIZE) * (40 / 144));
      line-height: calc(var(--ROOTFONTFIZE) * (40 / 144));
      font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
      color: var(--Select-color2);
      border: none;
      background-color: var(--Btn-bgc);
    }
  }
}

.popikoj {
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  margin-left: calc(var(--ROOTFONTFIZE) * (44 / 144));
  /deep/.el-input {
    margin-left: 15px;
  }
}
.ysdgs {
  margin-left: calc(var(--ROOTFONTFIZE) * (40 / 144));
}
</style>
